import { uniqueId } from 'lodash-es';

export default class AudioManager
{
    constructor ()
    {
        this.soundsQueue = {};
        this.bindEvents();
    }

    bindEvents ()
    {
        window.addEventListener( 'audiomanager:playsound', ( event ) =>
        {
            const audioUrl = event?.detail?.url ?? null;

            if ( !audioUrl )
            {
                console.error( '[AudioManager] Cannot play sound. No URL found in event details.', event )
            } else
            {
                this.playSound( audioUrl );
            }
        } )
    }

    playSound ( url )
    {
        const audioEl = new Audio( url );
        const id      = uniqueId()

        this.killAllAudio();


        audioEl.addEventListener( 'ended', () => this.dequeueAudio( id ) );

        audioEl.play();

        this.soundsQueue[ id ] = audioEl;

        console.log( '[AudioManager] Playing ' + url + '  ID: ' + id, this.soundsQueue );

    }

    killAllAudio ()
    {

        let queueIds = Object.keys( this.soundsQueue );

        if ( queueIds.length < 1 )
        {
            // nothing to stop
            return;
        }

        queueIds.forEach( ( id ) =>
        {
            if ( typeof this.soundsQueue[ id ] !== 'undefined' )
            {
                this.soundsQueue[ id ].pause();
                delete this.soundsQueue[ id ];
            }

        } )

    }


    dequeueAudio ( id )
    {
        if ( typeof this.soundsQueue[ id ] !== 'undefined' )
        {
            delete this.soundsQueue[ id ];
        }

    }

}


export function audioManagerPlaySound ( url )
{
    if ( typeof url === 'undefined' || url.length < 1 )
    {
        console.error( '[AudioManager:audioManagerPlaySound] Cannot dispatch event because audio url is empty.' );
        return;
    }

    const audioEvent = new CustomEvent(
        'audiomanager:playsound',
        {
            detail : {
                url,
            },
        } );
    window.dispatchEvent( audioEvent );
}
